import HostPropertyEditor from "./hostproperty/views/HostPropertyEditor";

export default HostPropertyEditor;
